<template functional>
  <div>
    <h1 class="title font-medium text-3xl text-secondary leading-tight mb-5 touch:text-2xl laptop-l:text-4xl">
      {{ props.title }}
    </h1>
    <h2 class="sub-title font-medium text-lg text-primary-light mb-25 laptop:text-xl laptop:mb-40">
      {{ props.subTitle }}
    </h2>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
</style>
